const getObjectKeyByItsValue = <T, P>(object: T, value: P) => Object.keys(object).find(key => object[key] === value);

export default getObjectKeyByItsValue;
